import { Flex, FlexProps } from "@chakra-ui/layout";

function CustomTag({
  children,
  color,
  bg,
  w,
  ...rest
}: {
  children: any;
  color: string;
  bg?: string;
  w?: string | number;
} & FlexProps) {
  return (
    <Flex
      w={w}
      rounded="full"
      borderWidth={1}
      color={color}
      borderColor={color}
      borderStyle="solid"
      alignItems="center"
      justifyContent="center"
      px={"8px"}
      py={"4px"}
      fontSize="12px"
      opacity={0.8}
      bg={bg}
      {...rest}
    >
      {children}
    </Flex>
  );
}

export default CustomTag;
